import type { NextSeoProps } from 'next-seo';
import { NextSeo } from 'next-seo';
import { useContext } from 'use-context-selector';
import type { AccountContentContextType } from '../accountContentContext/AccountContentContext';
import { AccountContentContext } from '../accountContentContext/AccountContentContext';

type AccountSeoConnectedProps = {
  location: keyof Omit<AccountContentContextType, 'pendingProAccountMsg'>;
  seoOptions?: NextSeoProps;
};
export const AccountSeoConnected = ({
  location,
  seoOptions,
}: AccountSeoConnectedProps) => {
  const accountContentContext = useContext(AccountContentContext);
  if (!location || location === 'loading') return null;

  const locationData = accountContentContext[location];

  const seoData = locationData?.seo;

  if (!seoData) return null;

  return (
    <NextSeo
      {...seoOptions}
      title={seoData.title}
      description={seoData?.description}
    />
  );
};
